import React from "react";

import { Primary, Secondary } from "@churchofjesuschrist/eden-buttons";
import { AlertWarningFilled, LoadingSpinner } from "@churchofjesuschrist/eden-icons";
import { Row } from "@churchofjesuschrist/eden-row";
import { accentColorWarning } from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import useTranslation from "../../../utils/use-translations";
import RippleEffectHolder from "../ripple-effect-holder/ripple-effect-holder";

const RippledPrimary = styled(Primary)`
  position: absolute;
  z-index: 1000;
`;

const WarnCustom = styled.div`
  display: inline-flex;
  align-items: center;
`;

const ACTIVE = "active",
  ACTIVE_ATTENTION = "active-attention",
  DISABLED = "disabled",
  HIDDEN = "hidden",
  SAVING = "saving";
const modes = [ACTIVE, ACTIVE_ATTENTION, DISABLED, HIDDEN, SAVING];

const stringGroups = [
  {
    name: "shared",
    keys: ["save", "cancel", "add", "apply"],
  },
];

const ContentPageFooter = ({
  mode: paramMode,
  showCancel = true,
  onSave,
  onCancel,
  small = false,
  adding = false,
  saveText: propSaveText,
  cancelText: propCancelText,
  canEdit = false,
  warning,
  ...otherProps
}) => {
  let mode = paramMode;
  const { managedStrings: useStrings } = useTranslation(stringGroups);
  if (modes.indexOf(mode) < 0) {
    mode = ACTIVE;
  }

  const saveText = propSaveText || (adding ? useStrings.add : useStrings.save);
  const cancelText = propCancelText || useStrings.cancel;
  return (
    <Row {...otherProps}>
      {mode === DISABLED && canEdit ? (
        <Primary small={small} disabled data-id="page-footer-save-disabled">
          {saveText}
        </Primary>
      ) : null}
      {mode === SAVING && canEdit ? (
        <Primary small={small} disabled data-id="page-footer-saving">
          <LoadingSpinner /> {saveText}
        </Primary>
      ) : null}
      {mode === ACTIVE && canEdit ? (
        <Primary
          small={small}
          onClick={onSave}
          data-id="page-footer-active"
          type="submit"
        >
          {saveText}
        </Primary>
      ) : null}
      {mode === ACTIVE_ATTENTION && canEdit ? (
        <RippleEffectHolder>
          <RippledPrimary
            small={small}
            onClick={onSave}
            data-id="page-footer-active-attention"
          >
            {saveText}
          </RippledPrimary>
          {/*Rippled is absolute positioned so it doesn't occupy
          space.  We put a hidden duplicate under rippled so it will take up
          the appropriate dom space */}
          <Primary>{saveText}</Primary>
        </RippleEffectHolder>
      ) : null}
      {showCancel && mode !== SAVING && canEdit ? (
        <Secondary
          small={small}
          onClick={onCancel}
          data-id="page-footer-cancel"
        >
          {cancelText}
        </Secondary>
      ) : null}
      {canEdit && warning ?
        <WarnCustom>
          <AlertWarningFilled size="1.5rem" color={accentColorWarning} /> {warning.message}
        </WarnCustom> : null
      }
    </Row>
  );
};

export default ContentPageFooter;
